export class NotFoundError extends Error {
  constructor(message?: string) {
    super(message || 'Ocorreu um erro');
    this.name = 'NotFoundError';
  }
}
